var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 276,
    viewBox: "0 0 279 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.433 207.175C137.433 202.261 141.414 198.281 146.328 198.281H197.928C204.981 198.281 211.717 200.367 216.902 204.182C222.088 207.997 226.208 213.99 226.208 221.435C226.208 228.879 222.095 234.873 216.909 238.688C211.723 242.502 204.981 244.595 197.928 244.595H75.3229C70.4086 244.595 66.4282 240.615 66.4282 235.701C66.4282 230.786 70.4086 226.806 75.3229 226.806H197.928C201.583 226.806 204.537 225.706 206.365 224.355C208.2 223.011 208.418 221.872 208.418 221.428C208.418 220.991 208.2 219.858 206.365 218.507C204.537 217.163 201.583 216.063 197.921 216.063L145.805 214.315C140.897 214.322 137.433 212.083 137.433 207.175Z",
    fill: "url(#paint0_linear_2572_7742)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.373 100.969C219.546 96.598 223.506 93.5515 228.036 93.5515H268.489C274.013 93.5515 278.49 98.0286 278.49 103.552C278.49 109.076 274.013 113.553 268.489 113.553H235.719L224.049 157.165C222.619 162.503 217.141 165.669 211.803 164.239C206.465 162.808 203.299 157.331 204.73 151.993L218.373 100.969Z",
    fill: "url(#paint1_linear_2572_7742)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.73 63.5427H88.3966L78.8264 84.4647H200.153L209.73 63.5427Z",
    fill: "url(#paint2_linear_2572_7742)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.607 60.3769H69.2434L78.8269 84.4581H158.177L148.607 60.3769Z",
    fill: "url(#paint3_linear_2572_7742)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.353 60.3769H167.76L158.177 84.4581H201.769L211.353 60.3769Z",
    fill: "url(#paint4_linear_2572_7742)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.776 84.4581H122.419V163.821H201.783V84.4581H201.776Z",
    fill: "url(#paint5_linear_2572_7742)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.183 84.4581H78.8264V163.821H158.19V84.4581H158.183Z",
    fill: "url(#paint6_linear_2572_7742)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.941 275.339C116.909 275.339 126.605 265.636 126.605 253.675C126.605 241.714 116.902 232.012 104.941 232.012C92.9736 232.012 83.2776 241.714 83.2776 253.675C83.2776 265.636 92.9736 275.339 104.941 275.339Z",
    fill: "#19A8D4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M212.466 120.368H63.1571C51.9642 120.368 43.6988 129.859 46.2287 139.793L58.3952 198.208C60.2231 205.381 67.2435 210.467 75.3235 210.467L206.969 218.984L229.427 139.82C234.957 123.613 223.678 120.368 212.466 120.368Z",
    fill: "url(#paint7_linear_2572_7742)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.339 264.597C110.353 264.597 115.22 259.722 115.22 253.715C115.22 247.708 110.346 242.833 104.339 242.833C98.3252 242.833 93.4573 247.708 93.4573 253.715C93.4573 259.722 98.3318 264.597 104.339 264.597Z",
    fill: "url(#paint8_linear_2572_7742)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.528 165.278C158.965 165.305 161.713 168.113 161.674 171.55L161.117 216.852C161.078 220.289 158.256 223.051 154.819 223.018C151.382 222.991 148.633 220.183 148.673 216.746L149.229 171.444C149.275 168.014 152.09 165.252 155.528 165.278Z",
    fill: "#19A8D4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M257.594 129.031L257.607 131.104C257.627 133.965 255.323 136.29 252.461 136.303L43.7977 136.839C40.9366 136.846 38.5987 134.534 38.5788 131.667L38.5656 129.594C38.5457 126.733 40.8505 124.408 43.7116 124.395L252.375 123.858C255.236 123.852 257.574 126.17 257.594 129.031Z",
    fill: "#19A8D4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M190.681 165.431C194.119 165.457 196.867 168.265 196.828 171.703L196.271 217.004C196.231 220.441 193.41 223.203 189.973 223.17C186.535 223.143 183.787 220.335 183.827 216.898L184.383 171.597C184.429 168.166 187.244 165.404 190.681 165.431Z",
    fill: "#19A8D4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.373 165.133C123.81 165.159 126.558 167.967 126.519 171.405L125.962 216.706C125.923 220.143 123.101 222.905 119.664 222.872C116.227 222.845 113.478 220.037 113.518 216.6L114.074 171.299C114.114 167.861 116.935 165.1 120.373 165.133Z",
    fill: "#19A8D4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8337 165.133C88.2711 165.159 91.0196 167.967 90.9799 171.405L90.4235 216.706C90.3838 220.143 87.5624 222.905 84.1251 222.872C80.6877 222.845 77.9392 220.037 77.9789 216.6L78.5353 171.299C78.5816 167.861 81.403 165.1 84.8337 165.133Z",
    fill: "#19A8D4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.973 3.4524C181.457 0.796584 178.648 -0.448537 176.695 0.664124C174.741 1.77679 174.383 4.8366 175.9 7.49242C175.946 7.56527 175.986 7.64475 176.032 7.7176C175.039 7.92291 174.105 8.88987 173.741 10.2277C173.271 11.9497 173.92 13.6253 175.185 13.9763C176.456 14.3207 177.867 13.2081 178.337 11.4861C178.463 11.0158 178.509 10.5456 178.483 10.1085C179.735 10.7907 181.092 10.9099 182.185 10.2873C183.145 9.73761 183.722 8.72429 183.874 7.51229C184.139 7.65137 184.424 7.76396 184.728 7.84344C186.45 8.31367 188.126 7.66462 188.477 6.39963C188.821 5.12801 187.709 3.71732 185.987 3.24709C184.881 2.94243 183.788 3.10138 183.059 3.59811C183.026 3.54512 183 3.49876 182.973 3.4524Z",
    fill: "#19A8D4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.3242 13.8505C92.4368 14.7578 91.3175 15.2281 90.185 15.0559C88.8736 14.8506 87.847 13.824 87.3106 12.3934C87.0722 12.718 86.7675 13.0226 86.4099 13.2875C84.966 14.3406 83.1712 14.334 82.3963 13.2743C81.6214 12.2146 82.1579 10.4993 83.5951 9.4462C84.7409 8.6117 86.1052 8.43951 87.0125 8.93623C87.4894 5.9294 89.6617 3.77693 91.8804 4.1147C94.066 4.45247 95.4767 7.09504 95.0793 10.0555C95.9337 10.1482 96.8543 10.6979 97.5166 11.5987C98.5696 13.0359 98.563 14.8373 97.5034 15.6122C96.4437 16.3871 94.7283 15.8506 93.6686 14.4134C93.5428 14.2346 93.4236 14.0426 93.3242 13.8505Z",
    fill: "#19A8D4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5638 131.349C13.1003 129.124 16.2594 129.124 16.7959 131.349L18.604 138.826C18.796 139.621 19.4186 140.237 20.2067 140.429L27.6841 142.237C29.9094 142.773 29.9094 145.933 27.6841 146.469L20.2067 148.277C19.412 148.469 18.7894 149.092 18.604 149.88L16.7959 157.357C16.2594 159.583 13.1003 159.583 12.5638 157.357L10.7557 149.88C10.5637 149.085 9.9411 148.469 9.14634 148.277L1.66899 146.469C-0.556331 145.933 -0.556331 142.773 1.66899 142.237L9.14634 140.429C9.9411 140.237 10.5637 139.614 10.7557 138.826L12.5638 131.349Z",
    fill: "#19A8D4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M242.7 205.983C243.236 203.758 246.395 203.758 246.932 205.983L248.74 213.461C248.932 214.255 249.554 214.871 250.342 215.063L257.82 216.871C260.045 217.408 260.045 220.567 257.82 221.103L250.342 222.912C249.548 223.104 248.932 223.726 248.74 224.514L246.932 231.992C246.395 234.217 243.236 234.217 242.7 231.992L240.891 224.514C240.699 223.72 240.077 223.104 239.289 222.912L231.811 221.11C229.586 220.574 229.586 217.414 231.811 216.878L239.289 215.07C240.083 214.878 240.699 214.255 240.891 213.467L242.7 205.983Z",
    fill: "#19A8D4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3475 77.9875C46.8444 77.9875 48.8644 75.9608 48.8644 73.4706C48.8644 70.9737 46.8378 68.9537 44.3475 68.9537C41.8507 68.9537 39.8307 70.9803 39.8307 73.4706C39.8307 75.9675 41.8573 77.9875 44.3475 77.9875ZM44.3475 81.3784C48.7121 81.3784 52.2554 77.8351 52.2554 73.4706C52.2554 69.106 48.7121 65.5627 44.3475 65.5627C39.983 65.5627 36.4397 69.106 36.4397 73.4706C36.4397 77.8351 39.983 81.3784 44.3475 81.3784Z",
    fill: "#19A8D4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0883 194.161C25.7439 192.81 26.9956 191.585 28.3401 191.962L37.4202 194.512C38.7647 194.89 39.1952 196.585 38.1951 197.559L31.4463 204.149C30.4462 205.122 28.764 204.652 28.4196 203.301L26.0883 194.161Z",
    fill: "#19A8D4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M261.098 163.027C262.449 162.682 263.667 163.934 263.29 165.278L260.727 174.358C260.349 175.703 258.654 176.133 257.68 175.133L251.104 168.378C250.13 167.378 250.607 165.696 251.958 165.351L261.098 163.027Z",
    fill: "#19A8D4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.46 68.2914C233.467 68.2914 235.089 66.6688 235.089 64.662C235.089 62.6552 233.467 61.0326 231.46 61.0326C229.453 61.0326 227.83 62.6552 227.83 64.662C227.83 66.6621 229.46 68.2914 231.46 68.2914ZM231.46 71.0134C234.97 71.0134 237.811 68.1722 237.811 64.662C237.811 61.1518 234.97 58.3106 231.46 58.3106C227.95 58.3106 225.108 61.1518 225.108 64.662C225.108 68.1656 227.956 71.0134 231.46 71.0134Z",
    fill: "#19A8D4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2878 118.427H228.738C232.46 118.427 235.473 121.447 235.473 125.163C235.473 128.885 232.453 131.899 228.738 131.899H46.2878C42.5657 131.899 39.5522 128.878 39.5522 125.163C39.5522 121.447 42.5657 118.427 46.2878 118.427Z",
    fill: "url(#paint9_linear_2572_7742)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4361 16.95C87.6479 24.0896 93.4297 39.0841 102.351 40.2762C118.862 42.475 115.829 23.169 105.98 26.7984C94.2576 31.1166 105.987 49.5881 122.048 53.754",
    stroke: "#19A8D4",
    strokeWidth: 1.5652,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.26 6.26"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M183.264 15.1486C193.073 34.2427 167.084 54.6282 159.885 58.4099",
    stroke: "#19A8D4",
    strokeWidth: 1.5652,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.26 6.26"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M173.866 275.339C185.834 275.339 195.53 265.636 195.53 253.675C195.53 241.714 185.828 232.012 173.866 232.012C161.905 232.012 152.203 241.714 152.203 253.675C152.203 265.636 161.905 275.339 173.866 275.339Z",
    fill: "#19A8D4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M173.794 264.597C179.808 264.597 184.676 259.722 184.676 253.715C184.676 247.708 179.801 242.833 173.794 242.833C167.78 242.833 162.913 247.708 162.913 253.715C162.913 259.722 167.787 264.597 173.794 264.597Z",
    fill: "url(#paint10_linear_2572_7742)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2572_7742",
    x1: 72.2311,
    y1: 152.579,
    x2: 120.585,
    y2: 200.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EE2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2572_7742",
    x1: 315.903,
    y1: 127.303,
    x2: 207.573,
    y2: 129.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EE2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2572_7742",
    x1: 78.5559,
    y1: 71.3315,
    x2: 210.11,
    y2: 76.6754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19A8D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2572_7742",
    x1: 113.71,
    y1: 60.3787,
    x2: 113.71,
    y2: 84.4619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9ECF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2572_7742",
    x1: 184.763,
    y1: 60.3787,
    x2: 184.763,
    y2: 84.4619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92DDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2572_7742",
    x1: 120.361,
    y1: 123.481,
    x2: 235.015,
    y2: 125.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3922,
    stopColor: "#19A8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2572_7742",
    x1: 102.854,
    y1: 120.063,
    x2: 145.921,
    y2: 131.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2572_7742",
    x1: 45.3938,
    y1: 167.712,
    x2: 230.697,
    y2: 169.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2572_7742",
    x1: 92.8921,
    y1: 253.531,
    x2: 124.344,
    y2: 254.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2572_7742",
    x1: 241.163,
    y1: 143.427,
    x2: 33.2817,
    y2: 106.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19A8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52D2EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2572_7742",
    x1: 162.347,
    y1: 253.531,
    x2: 193.799,
    y2: 254.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyShoppingCart);
export default __webpack_public_path__ + "static/media/EmptyShoppingCart.a2fafdb901f87c031044d4658dfbea1e.svg";
export { ForwardRef as ReactComponent };